import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { LoyaltyProgram } from '@rd/types';
import { TransferConnectV2WrapperComponentDirective } from '../../transfer-connect-v2-wrapper.component';

@Component({
  selector: 'rd-tcv2-checkout-terms-list-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  styleUrls: ['./checkout-terms-list-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2CheckoutTermsListWrapperComponent extends TransferConnectV2WrapperComponentDirective {
  @HostBinding('class.rd-tcv2-checkout-terms-list-wrapper')
  componentClass = true;
  @Input() loading: boolean;
  @Input() loyaltyProgram: LoyaltyProgram;

  componentName = 'tcv2-checkout-terms-list';
}
